/**
 * @class
 * @property {string} vendor
 * @property {string} project_NaN
 * @property {string} project_description
 * @property {string} customer
 * @property {string} project_manager
 * @property {string} invoice_NaN
 * @property {number|null} total
 */

import uuid4 from "uuid4";
const generate_uuid: () => string = uuid4;

export default class Uuid {
    public uuid: string;

    constructor(uuid?: string) {
        if (typeof uuid !== 'undefined') {
            if (this.is_valid_uuid(uuid)) {
                this.uuid = uuid
            } else {
                //TODO: throw error here
            }
        } else {
            this.uuid = generate_uuid()
        }
    }

    public is_valid_uuid(uuid: string): boolean {
        const uuidV4Regex = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        return uuidV4Regex.test(uuid);
    }

    public set(uuid) {
        if (this.is_valid_uuid(uuid)) {
            this.uuid = uuid
        } else {
            //TODO: throw error here
        }
    }

    public get() {
        return this.uuid
    }
}